// Venobox lightbox, used for front page video.
import $ from 'jquery';
$(function() {
  'use strict';
  // Social Share Block Start
  // $(window).load(function () {
  //   // Execute after everything is loaded
  //   var element = $('.follow-scroll');
  //
  //   if(element.length){
  //     var originalY = element.offset().top;
  //     // Space between element and top of screen (when scrolling)
  //     var topMargin = 210;
  //
  //     var parentHeight = element.parent().outerHeight() - topMargin;
  //
  //     // Should probably be set in CSS; but here just for emphasis
  //     element.css('position', 'relative');
  //
  //     $(window).on('scroll', function() {
  //       var scrollTop = $(window).scrollTop();
  //
  //       if((scrollTop - originalY + topMargin) < parentHeight){
  //         element.stop(false, false).animate({
  //           top: scrollTop < originalY
  //             ? 0
  //             : scrollTop - originalY + topMargin,
  //         }, 300);
  //       }
  //     });
  //   }
  // });
  // Social Share Block End
  // Smooth Scroll to Anchors Start
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 150,
    }, 500);
  });
  // Smooth Scroll to Anchors End

  // Autoexpand case-study links
  $('a.case-study').click(function(e){
    e.preventDefault();
    $(this).closest('article').toggleClass('opened');
  });


  if ($('.card-expand').length){
    $('.card-expand').click(function(e){
      e.preventDefault();
      $(this).toggleClass('opened');
    });
  }
  $('.venobox').venobox(); 
});

// Sticky header.
window.onscroll = function() {
  var distance = $(window).scrollTop();
  if (distance > 1) {
    $("body").addClass("fix-header");
  } else {
    $("body").removeClass("fix-header");
  }
};

// Format large quotes for pre-footer image on specialty landing pages.
$(function() {
  if ( document.getElementsByClassName("pre-footer-image").length > 0 ) {
    if ( document.getElementsByClassName("pre-footer-text").length > 0 ) {
      var div = document.getElementsByClassName("pre-footer-text")[0];
      var textInDiv = div.getElementsByTagName('p')[0].innerHTML;
      var numChars = textInDiv.length;
      if ( numChars > 220 ) {
        div.style.setProperty('max-width', '50%' );
      } 
      if ( numChars > 640 ) {
        div.style.setProperty('max-width', '75%' );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./scripts/util/foursite-child.js